<template>
    <div class="nav-bar-buttons-wrapper">
        <button class="header-menu-button"
            :class="{ dropdownOpened: isDropdownOpen }" 
            @click="toggleDropdown"
        >
            <MenuIcon fill="currentColor" />
        </button>
        <div
            v-show="isDropdownOpen"
            class="header-menu-dropdown"
            ref="dropdown"
            @click.stop
        >
            <div class="header-menu-dropdown-wrapper">
                <ul>
                    <li v-for="(menu, key) in menu_options" :key="key">
                        <a v-if="!menu.isModal" :href="menu.link">{{ menu.label }}</a>
                        <button v-else @click="$bvModal.show('AdvertiseModal')">{{ menu.label }}</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import MenuIcon from '@/components/icons/MenuIcon.vue'
    import 'vue-select/dist/vue-select.css';
    import "@/assets/scss/custom/triplea/components/_header_menu_dropdown.scss";

    export default {
    components: {
        MenuIcon,
    },
    computed: {
    },
    data() {
        return {
            isDropdownOpen: false,
            menu_options: [
                {"link":"https://www.apolar.com.br/comprar", "label":"Vendas"},
                {"link":"https://www.apolar.com.br/alugar", "label":"Locação"},
                {"link":"/lancamentos", "label":"Lançamentos"},
                {"link":"https://procura.apolar.com.br/", "label":"Apolar Procura"},
                {"link":"https://www.apolar.com.br/consorcio/", "label":"Consórcio"},
                {"link":"https://www.apolar.com.br/triplea", "label":"Triple A"},
                {"link":"https://www.apolar.com.br/temporada", "label":"Temporada"},
                {"link":"https://www.apolar.com.br/feirao-apolar", "label":"Feirão Apolar"},
                {"link":"https://www.apolar.com.br/franquias/", "label":"Lojas Apolar"},
                {"link":"https://www.apolar.com.br/invista", "label":"Para Investidores"},
                {"link":"https://www.apolar.com.br/b4b", "label":"Build for Business"},
                {"link":"https://shortstay.apolar.com.br/", "label":"Apolar Short Stay"},
                {"link":"https://franqueado.apolar.com.br", "label":"Seja um Franqueado"},
                {"link":"https://opsganhei.com.br/", "label":"Indique"},
                {"link":"https://www.apolar.com.br/anuncie", "label":"Anuncie"},
                {"link":"/triplea/busca?residencial", "label":"Comprar"},
                {"link":"/triplea/busca?mensal", "label":"Alugar"},
                {"link":"http://localhost:8080/triplea#", "label":"Produtos Apolar"},
                {"link":"", "label":"Anunciar Imóveis", "isModal":true, "props":""},
                {"link":"https://franqueado.apolar.com.br/", "label":"Seja um Franqueado"},
            ]
        }
    },
    methods: {
        // control menu dropdown
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        closeDropdown() {
            this.isDropdownOpen = false;
        }
    },
    mounted() {
    }
    };
</script>
<style>
    .nav-bar-buttons-wrapper {
        display: flex;
        gap: 1.75rem;
        position: relative;
    }
    .header-menu-button {
        border: none;
        background-color: unset;
        display: flex;
        align-items: center;
        gap: 5px;
        color: #FBBC05;
        transition: all 0.3s ease;

        span {
            color: #333333;
            font-weight: bold;
            font-size: 16px;
            
            @include for-phone-only {
                display: none;
            }
        }
        
        &.dropdownOpened {
            color: #A67B3D;
            transform: scale(1.05);
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            
            span {
                color: #A67B3D;
            }
        }
    }
</style>